import React, { useEffect, useState } from 'react';
// Constants
import {
  CompanyName,
  KeywordsPages,
  LocationCountry,
  MainTitle,
} from '../../utils/Constants';
// Data
import {
  onlinePageAdditionalMeta,
  onlinePageStructuredData,
} from '../../utils/data/MetaData';
// Components
import Navbar from '../../components/nav/Navbar';
import { HelmetItem } from '../../components/utils/HelmetItem';
import GeneralHeader from '../../components/header/GeneralHeader';
import FooterComponent from '../../components/footer/FooterComponent';
import OnlinePageMainContainer from '../../components/online/OnlinePageMainContainer';

function OnlinePage() {
  const [hideNavbar, setHideNavbar] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const section = document.getElementById('scroll-section-online-sessions');
      if (!section) return;

      const sectionBottom = section.getBoundingClientRect().bottom;
      setHideNavbar(sectionBottom <= 130); // Hide navbar 50px before section disappears
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      {/* Tab Data */}
      <HelmetItem
        PageName='Online Sessions'
        desc={`Connect with ${CompanyName} for exclusive bookings and inquiries. Discretion and professionalism guaranteed.`}
        keywords={`contact, bookings, dominatrix, elite sessions, ${CompanyName}, ${LocationCountry}, private requests ${KeywordsPages}`}
        additionalMeta={onlinePageAdditionalMeta}
        structuredData={onlinePageStructuredData}
      />

      {/* Page */}
      <div className='grid min-h-screen font-main bg-colour1 dark:bg-colour2 text-colour2 dark:text-colour1 overflow-hidden'>
        {/* Nav + header section */}
        <div
          id='scroll-section-online-sessions'
          className='grid bg-colour4 dark:bg-colour4 full_shadow_black_invert min-h-[45vh] max-h-[45vh]'
        >
          {/* Navigation */}
          <Navbar isHidden={hideNavbar} />
          {/* Header */}
          <GeneralHeader
            page={`Online Sessions`}
            title={`${MainTitle}`}
            subtitle={`Online domination sessions and content`}
          />
        </div>

        {/* Main content */}
        <OnlinePageMainContainer />

        {/* Footer */}
        <FooterComponent />
      </div>
    </>
  );
}

export default OnlinePage;
